export enum SupportedLanguages {
  English = "en",
  Spanish = "es",
  German = "de",
  Chinese = "zh",
  French = "fr",
  Italian = "it",
  Portuguese = "pt",
  Japanese = "ja",
  Russian = "ru",
  Hindi = "hi",
  Korean = "ko",
}
